export const COLLECT_PAGE_SIZE = 100;

/**
 * Teto de páginas percorridas (10 000 registros): protege a tela de um serviço
 * que devolva sempre uma página cheia e nunca sinalize o fim da coleção.
 */
export const COLLECT_MAX_PAGES = 100;

export interface CollectedPage<T> {
  items: T[];
  total: number;
}

/**
 * Percorre a consulta página a página e devolve o conjunto completo do
 * resultado, e não apenas a página exibida. Para na primeira página incompleta,
 * ao alcançar o total informado pelo serviço ou no teto de páginas.
 */
export async function collectAllPages<T>(
  fetchPage: (page: number, pageSize: number) => Promise<CollectedPage<T>>,
  pageSize = COLLECT_PAGE_SIZE,
): Promise<T[]> {
  const collected: T[] = [];

  for (let page = 1; page <= COLLECT_MAX_PAGES; page += 1) {
    const { items, total } = await fetchPage(page, pageSize);

    collected.push(...items);

    if (items.length < pageSize || collected.length >= total) break;
  }

  return collected;
}
